import React, { FC } from 'react';
import cx from 'classnames';
import { sortBy, startCase } from 'lodash';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import fallback from 'file-loader!@/assets/images/fallback-sample.png'; // eslint-disable-line
import { SampleOption } from '@/components/Common/SampleSelector';
import { Option } from '@/types/index';
import ButtonGroup from '@/components/Common/ButtonGroup';
import { type Props } from './types';
import * as styles from '../ProductConfigurator.module.scss';

const emptyOption: SampleOption = { code: '', name: '', image: fallback };

const BundleOptionProductSelectorMaterial: FC<Props> = ({
  className,
  option,
  value,
  onChange,
  characteristicIndex,
}) => {
  const options: SampleOption[] = [
    ...sortBy(option.products, 'position').map((product) => ({
      code: product.sku,
      name:
        startCase(
          product?.pim?.characteristics?.[characteristicIndex ?? 0]?.materials?.[0] ?? ''
        ) || product.name,
      image: product.pim?.thumbnail?.childImageSharp?.gatsbyImageData || fallback,
    })),
  ];

  const asOption = ({ name, code }: SampleOption): Option => [name, code!];
  const selectedOption = options.find((o) => o.code === value);

  return (
    <ButtonGroup
      className={cx(styles.buttonGroup, className)}
      label={i18n._(t`Select product`)}
      defaultValue={selectedOption ? asOption(selectedOption)[1] : undefined}
      options={[...(!option.isRequired ? [emptyOption] : []), ...options].map(asOption)}
      onChange={onChange}
    />
  );
};

export default BundleOptionProductSelectorMaterial;
